import * as types from '../../mutation-types'
import discount from './discount'
import catalog from './catalog'
import dashboard from './dashboard'
import inventary from './inventary'
import users from './users'
import orders from './sales'
// import statistics from './statistics'
// import ui from './ui'
// import tables from './tables'
// import auth from './auth'
// import extra from './extra'

const state = {
  items: [
    dashboard,
    users,
    discount,
    catalog,
    orders,
    inventary,
    // statistics,
    // tables,
    // ui,
    // extra,
    // auth,
  ]
}

const mutations = {
  [types.TOGGLE_EXPAND_MENU_ITEM] (state, payload) {
    let menuItem = payload.menuItem
    let expand = payload.expand
    if (menuItem.children && menuItem.meta) {
      menuItem.meta.expanded = expand
    }
  }
}

const actions = {
  toggleExpandMenuItem ({commit}, payload) {
    commit(types.TOGGLE_EXPAND_MENU_ITEM, payload)
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/index.js